import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "@/context/Lang";

export default function MarqueeBar() {
  const { t } = useLang();
  const words = t.marquee.split(" ✦ ").filter(Boolean);
  return (
    <div className="bg-gold text-navy py-4 border-y-2 border-navy" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="font-display font-black uppercase text-lg md:text-2xl tracking-tight mx-6">
            {w} <span className="text-orange mx-3">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
